import { IEirSalesAskAvailableAppointments } from "@modules/eirSalesFacade/interfaces/models/IEirSalesAskAvailableAppointments";
import { IEirSalesAskAvailableAppointmentsResponse } from "@modules/eirSalesFacade/interfaces/responses/IEirSalesAskAvailableAppointmentsResponse";
import { EEirSalesViewAvailableAppointmentsStatus } from "../constants";

export const mapEirSalesAskAvailableAppointmentsResponse = (
    response: IEirSalesAskAvailableAppointmentsResponse
): IEirSalesAskAvailableAppointments => ({
    reference: response.reference,
    status: response.status as EEirSalesViewAvailableAppointmentsStatus,
    availableSlots: response.availableSlots,
    canUsePreviousSlots: response.canUsePreviousSlots,
    canUseNextSlots: response.canUseNextSlots,
});
